import type { FC } from "react";
import { useEffect } from "react";
import { DatePage as DatePageComponent } from "../components/pages/date";

export const DatePage: FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <DatePageComponent />;
};

export default DatePage; 